import React from 'react';
import Highcharts from 'highcharts';
window.Highcharts = Highcharts;
require('highcharts/modules/exporting')(Highcharts);

const AppBarHeight = 64;

class GB_TStdChart extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            id        : this.props.id,
            packChart : this.props.packChart,
            stretch   : this.props.stretch,
            minHeight : this.props.minHeight,
            maxHeight : this.props.maxHeight,
            chart     : null,
            chartType : this.props.chartType
        };
    }

    // componentWillReceiveProps (nextProps) {
    //     //console.log(nextProps.packChart);
    //     this.setState({packChart: nextProps.packChart});
    //     //this.state.chart.update(this.getOptions(nextProps.packChart));
    //     // this.state.chart.update({
    //     //     chart: {
    //     //         type: nextProps.chartType
    //     //     }
    //     // });
    // }

    getChartHeight = () => {

        // 1) Stretch the chart to the very bottom?
        if (this.state.stretch) {
            if (!(this.state.chart === null)) {
                let div = this.state.chart.renderTo;
                let space = window.innerHeight - div.offsetTop;
                return space;
            }
        }

        // 2) Or use a custom min/max height
        let height = window.innerHeight - AppBarHeight;
        let minHeight = this.state.minHeight;
        let maxHeight = this.state.maxHeight;

        if ((height > minHeight) && (height < maxHeight)) {
            return height;
        }
        else if (height < minHeight) {
            return minHeight;
        }
        else if (height > maxHeight) {
            return maxHeight;
        }
        else {
            return undefined;
        }
    };

    onResize = () => {
        if (!(this.state.chart === null)) {
            this.state.chart.setSize(undefined, this.getChartHeight(), false);
        }
    };

    getOptions = (o) => {

        // o = packChart, shortened for easier readability

        const getChartType = (chartType) => {

            const CH_Line                   = 1;
            const CH_Bar                    = 2;
            const CH_Bar_3D                 = 3;
            const CH_HORIZONTAL_BAR         = 4;
            const CH_HORIZONTAL_BAR_3D      = 5;
            const CH_STACKED_BAR            = 6;
            const CH_POINT                  = 7;
            const CH_Table                  = 8;
            const CH_Pie                    = 9;
            const CH_3D_GRAPH               = 10;
            const CH_POINT_LINE             = 11;
            const CH_HORIZONTAL_STACKED     = 12;

            switch(chartType) {
                case CH_Line                   : return 'line';
                case CH_Bar                    : return 'column';
                case CH_Bar_3D                 : return 'column';
                case CH_HORIZONTAL_BAR         : return 'bar';
                case CH_HORIZONTAL_BAR_3D      : return 'bar';
                case CH_STACKED_BAR            : return 'column';
                case CH_POINT                  : return 'point';
                case CH_Table                  : return null;
                case CH_Pie                    : return 'pie';
                case CH_3D_GRAPH               : return null;
                case CH_POINT_LINE             : return 'line';
                case CH_HORIZONTAL_STACKED     : return 'column';
                default                        : return 'line';
            }
        };

        const getSubtitle = (subTitle, multiSubTitles) => {
            if (subTitle !== '') {
                return subTitle;
            }
            else if (multiSubTitles !== 'undefined') {
                let s = '';
                let len = multiSubTitles.length-1;

                for (let i = 0; i < len; i++) {
                    s += multiSubTitles[0];
                    if (i < len) {
                        s += '<br />';
                    }
                }
                return s;
            }
            else {
                return undefined;
            }
        };

        const getLegendAlign = (legendLocation) => {

            // eLegendLocation
            const gLegendTop    = 0;
            const gLegendBottom = 1;
            const gLegendLeft   = 2;
            const gLegendRight  = 3;

            switch(legendLocation) {
                case gLegendTop    : return 'top';
                case gLegendBottom : return 'bottom';
                case gLegendLeft   : return 'left';
                case gLegendRight  : return 'right';
                default            : return 'top';
            }
        };

        const getYAxisMin = (manualMinY, manualStackedMinY, stacking) => {
            if (stacking) {
                return manualStackedMinY;
            }
            else {
                return manualMinY;
            }
        };

        const getYAxisMax = (manualMaxY, manualStackedMax, stacking) => {
            if (stacking) {
                if (manualStackedMax > 0) {
                    return manualStackedMax;
                }
                else {
                    return undefined;
                }
            }
            else {
                if (manualMaxY > 0) {
                    return manualMaxY;
                }
                else {
                    return undefined;
                }
            }
        };

        function getTooltipFormat(e) {
            let s = '<b>' + this.x + '</b>';

            // this.points.forEach( (item) => {
            //     if (item.series.name === that) {
            //         s += '<br/>' + Math.round(item.y) + '%';
            //     }
            // });

            return s;

        }

        const onHotSpotClick = (event) => {

            // let s;
            // s += '<b>Subset</b><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + event.point.series.name;
            // s += '<b>Point</b><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + event.point.category;
            // s += '<b>Value</b><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + event.point.y;
            // s += '<b>' + event.point.value2Lab</b><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + event.point.category;
            // s += '<b>Point</b><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + event.point.category;


            // s += '<h2>value2</h2>';
            // s += 'Insert something here';
            //s += o.value2[event.point.x];

            //alert('You just clicked the graph');
            //alert(s);
            //return "<b>" + event.point.y + "</b>";
        };

        const getSeries = (subsetLabels, subsetColors, subsetsToLegend, chartData, dash) => {

            let series = chartData.map( (arr2, subset) => {
                return {
                    name: subsetLabels[subset],
                    //color: this.getDelphiColorToHex(subsetColors[subset]),
                    color:subsetColors[subset],
                    index: subsetsToLegend[subset],
                    visible: !(subsetsToLegend[subset] === -1),
                    data : chartData[subset]
                    // arr2.map((value, point) => {
                    //     return {
                    //         y: value
                    //     }
                    // })
                };
            });

            return series;
        };

        const formArray = (dat) => {
            var arr = [];
            for (var i = 0; i < dat.length; i++) {
                arr.push(dat[i][0][0]);
            }
            return arr;
        };

        return {
            chart : {
                type: this.state.chartType, //getChartType(o.chartType),
                height: '900px',
                zoomType: 'xy',
                inverted:o.title === "Distribution of youth by marital status, sexual activity, and contraceptive use" ? true : false
            },

            title : {
                text: o.title,
                subTitle: getSubtitle(o.subTitle, o.multiSubTitles)
            },

            exporting: {
                enabled:false
            },

            legend : {
                enabled: o.showLegend,
                verticalAlign: getLegendAlign(o.legendLocation)
            },

            plotOptions : {
                column : {
                    stacking : o.stacking
                },
                bar : {
                    stacking : o.stacking,
                    dataLabels: {
                        enabled: true,
                        formatter: function() {
                            return Math.round(this.y) + "%";
                        }
                    }
                },
                line: {
                    marker: {
                        enabled: false
                    },
                },
                series: {
                    cursor : 'pointer',
                    events : {
                        click : onHotSpotClick
                    },
                }
            },

            tooltip : {
                enabled: true,//o.allowPopup,
                //shared: true,
                //crosshairs: true,
                valueDecimals: 0,
                //formatter: getTooltipFormat
            },

            credits : {
                text : '',
                href : '',
                style : {
                    cursor: 'pointer'
                }
            },

            xAxis : {
                gridLineWidth: 0,
                title : {
                    text: o.xAxisLabel,
                },
                categories : o.pointLabels
            },

            yAxis : [
                {
                    gridLineWidth: 0,
                    title : {
                        text: o.yAxisLabel,
                    },
                    max : this.state.chartType === "bar" ? 100 : this.state.chartType === "column" ? Math.min(...formArray(o.chartData)) < 0 ? Math.max(Math.max(...formArray(o.chartData)), 10) : undefined : undefined,
                    min: 0,
                    labels: {
                        format: '{value}%'
                    }
                },
                // {
                //     title : o.RYAxisLabel,
                //     min: 0
                // },

            ],

            series : getSeries(o.subsetLabels, o.subsetColors, o.subsetsToLegend, o.chartData)
        };
    };

    getDelphiColorToHex = (color) => {

        if (color >= 0) {
            let hexString = color.toString(16);

            let R = hexString.slice(-2);
            let G = hexString.slice(-4, -2);
            let B = hexString.slice(-6, -4);

            return '#' + (R + G + B);
        }
        else {
            return '';
        }
    };

    componentWillReceiveProps (nextProps) {
        if (nextProps.packChart !== this.state.packChart) {
            var that = this;
            setTimeout(function() {
                that.setState({packChart: nextProps.packChart});
                let options = that.getOptions(that.state.packChart);
                options.chart.height = that.getChartHeight();
                that.setState({
                    chart: Highcharts.chart(that.state.id, options)
                });
            }, 250);
        }
    }

    componentDidMount () {
        window.addEventListener('resize', this.onResize);

        // When the DOM is ready, create the chart.
        let options = this.getOptions(this.state.packChart);
        options.chart.height = this.getChartHeight();
        this.setState({
            chart : Highcharts.chart(this.state.id, options)
        });

        this.onResize();
    }

    componentWillUnmount () {
        window.removeEventListener('resize', this.onResize);

        // Destroy chart before unmount.
        if (!(this.state.chart === null)) {
            this.state.chart.destroy();
        }
    }

    render() {
        return (
            <div id={this.state.id}></div>
        );
    }
}

export default GB_TStdChart;


// WEBPACK FOOTER //
// ./src/pages/GB/GBStdChart.js